<template>
  <div class="fill-height">
    <Loading :loading="isLoading"></Loading>
    <topNav />
    <div class="container mt-5">
      <h1>{{ lesson.name }}</h1>
      <b-row class="my-2 font-weight-bold" v-if="lesson.teachers.length > 0">
        <b-col>
          <span>ผู้สอน </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="teacher in lesson.teachers" :key="teacher.id" md="4" cols="12" class="mb-4">
          <b-card @click="teacherDetail(teacher.user.id)" class="mx-auto my-auto text-center">
            <template v-if="teacher.user">
              <b-avatar :src="teacher.user.profile_image"></b-avatar>
              <span>
                {{ teacher.user.first_name }} {{ teacher.user.last_name }}
              </span>
            </template>
          </b-card>
        </b-col>
        <b-col md="3" cols="12" class="mb-4" v-if="lesson.pdf">
          <button @click="downloadFile(lesson.pdf.url)" class="btn btn-light">
            Download เอกสาร
          </button>
        </b-col>
        <b-col md="3" cols="12" class="mb-4" v-if="lesson.is_external_link && lesson.external_link">
          <button @click="downloadFile(lesson.external_link)" class="btn btn-light">
            ลิ้งค์ระบบภายนอก
          </button>
        </b-col>
      </b-row>
      <b-row>
        <!-- <b-col md="3" cols="12" class="mb-4">
          <button class="btn btn-light">
            ถามตอบ เรื่องบทเรียน
          </button>
        </b-col> -->
      </b-row>
      
      <div v-if="lesson.media">
      
        <div v-if="lesson.media?.type === 'h5p' && !isLoading">
          <H5PPlayer :media="lesson.media" :enroll_id="courseStatus.enroll_id" :user_id="userData.id"
            :subject_id="lesson.subject_id" :lesson_id="lesson.id" :access_token="access_token"
            :lesson_status="lesson.progress?.status" :duration="lesson.media?.duration" :loading="isLoading" />
        </div>

        <b-row class="text-center" v-else>
          <b-col v-if="
            lesson.media ||
            lesson.video_lesson_id_360 > 0 ||
            lesson.video_lesson_id_480 > 0 ||
            lesson.video_lesson_id_720 > 0 ||
            lesson.video_lesson_id_1080 > 0
          " cols="12" class="my-3">
            <img style="max-width: 20%" class="absolute-img" src="../../public/logo.png" />
            <vue-plyr ref="player" :options="playerOptions" v-if="isGetContent">
              <video controls playsinline :id="lesson.id" @ended="videoEnd">
                <source v-if="
                  isGetContent &&
                  lesson.media &&
                  lesson.video_lesson_is_multi == 0
                " size="576" :src="lesson.media.url" type="video/mp4" />

                <!--              multi-->
                <source v-if="
                  isGetContent &&
                  lesson.video_lesson_is_multi == 1 &&
                  lesson.video_lesson_id_360 > 0
                " size="360" :src="lesson.video_lesson_360" type="video/mp4" />

                <source v-if="
                  isGetContent &&
                  lesson.video_lesson_is_multi == 1 &&
                  lesson.video_lesson_id_480 > 0
                " size="480" :src="lesson.video_lesson_480" type="video/mp4" />

                <source v-if="
                  isGetContent &&
                  lesson.video_lesson_is_multi == 1 &&
                  lesson.video_lesson_id_720 > 0
                " size="720" :src="lesson.video_lesson_720" type="video/mp4" />

                <source v-if="
                  isGetContent &&
                  lesson.video_lesson_is_multi == 1 &&
                  lesson.video_lesson_id_1080 > 0
                " size="1080" :src="lesson.video_lesson_1080" type="video/mp4" />
              </video>
            </vue-plyr>
          </b-col>
        </b-row>
      </div>

      <b-row v-if="lesson.pdf" class="my-2">
        <b-col lg="12" md="12" sm="12" cols="12">
          <PDFView ref="pdfView" :src="lesson.pdf.url" :page="page"></PDFView>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" md="12" sm="12" cols="12">
          <div>
            <b-tabs content-class="mt-5" align="left">
              <b-tab title="บทเรียน" active>
                <p v-html="lesson.description"></p>
                <b class="text-primary-100">เนื้อหาในคอร์สเรียน</b>
                <LessonList :selected="lesson" :lessons="course ? course.lessons : []" :answerCourse="answerCourse"
                  :courseStatus="courseStatus" :lessonProgress="progressResponse"
                  :enrollCheck="checkEnroll(course.enroll ?? [])" />
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal centered id="video-rule-modal" hide-header hide-footer :no-close-on-backdrop="true"
      :no-close-on-esc="true" @hidden="onVideoRuleHidden">
      <div class="text-center px-2 py-3">
        <h5 class="text-primary-100 mb-3">ก่อนเริ่มรับชมวิดีโอ</h5>
        <div class="text-left mx-auto" style="max-width: 320px">
          <div class="d-flex mb-2">
            <b-icon icon="play-circle" class="mr-2 mt-1 flex-shrink-0 text-primary-100"></b-icon>
            <span>กรุณารับชมวิดีโอต่อเนื่องจนจบ</span>
          </div>
          <div class="d-flex mb-2">
            <b-icon icon="slash-circle" class="mr-2 mt-1 flex-shrink-0 text-primary-100"></b-icon>
            <span>ไม่สามารถเลื่อนข้ามวิดีโอได้</span>
          </div>
          <div class="d-flex mb-2">
            <b-icon icon="eye" class="mr-2 mt-1 flex-shrink-0" style="color: green"></b-icon>
            <span>เมื่อรับชมจบ จะแสดงไอคอนดวงตาสีเขียว</span>
          </div>
        </div>
        <button @click="closeVideoRuleModal" class="btn btn-primary pill-btn mt-4 px-5">
          ตกลง
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import LessonList from "@/components/Lessons/LessonList";
import img from "@/assets/image/mock/overview.png";
import topNav from "@/components/topNav.vue";
import Loading from "@/components/Loading.vue";
import PDFView from "./PDFView.vue";
import { mapState } from "vuex";
import moment from "moment";
import H5PPlayer from "@/components/H5PPlayer.vue";

export default {
  data() {
    return {
      video_about: null,
      poster_video: img,
      isLoading: false,
      courseStatus: false,
      answerCourse: null,
      isGetContent: false,
      syncSlide: [],
      page: 1,
      playTime: 0,
      playTimeInterval: null,
      progressResponse: null,
      progressSaved: false,
      savingProgress: false,
      maxWatched: 0,
      isLessonWatched: false,
      resumeApplied: false,
      lastPositionSaveAt: 0,
      isSeeking: false,
      videoRuleAcknowledged: false,
      playerEventsBound: false,
      bindAttempts: 0,
      bindRetryTimer: null,
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.Auth.userData,
      access_token: (state) => state.Auth.access_token,
      course: (state) => {
        return state.Courses.course;
      },
      lesson: (state) => {
        return state.Lessons.lessons;
      },
    }),
    hasVideoLesson() {
      // mirrors the template: the plyr player only renders for media that is
      // not h5p (h5p lessons use H5PPlayer and have no seek lock)
      if (!this.lesson || !this.lesson.media) {
        return false;
      }
      return this.lesson.media.type !== "h5p";
    },
    playerOptions() {
      // Remove the speed panel so the video cannot be rushed. "quality" stays
      // because lesson videos ship several resolutions (360-1080).
      return {
        settings: ["captions", "quality", "loop"],
      };
    },
  },
  created() {
    this.isGetContent = false;
    this.changeFormatSyncSlide();
  },
  async mounted() {
    this.isLoading = true;
    await this.getContent();
    await this.checkCourseStatus();
    this.isLoading = false;

    await this.$nextTick();
    this.setupPlayerEvents();
    this.$forceUpdate();
  },
  beforeDestroy() {
    clearInterval(this.playTimeInterval);
    clearTimeout(this.bindRetryTimer);
    const player = this.$refs.player && this.$refs.player.player;
    if (player) {
      this.savePosition(player);
    }
  },
  components: {
    LessonList,
    PDFView,
    Loading,
    topNav,
    H5PPlayer

  },
  methods: {
    isShowPlayer() {
      return !this.isLoading;
    },
    setupPlayerEvents() {
      if (this.playerEventsBound) {
        return;
      }
      const playerRef = this.$refs.player;
      if (!playerRef || !playerRef.player) {
        // the plyr instance renders behind v-if, so retry briefly while it mounts
        if (this.bindAttempts < 20) {
          this.bindAttempts++;
          this.bindRetryTimer = setTimeout(() => this.setupPlayerEvents(), 150);
        }
        return;
      }
      this.playerEventsBound = true;
      const player = playerRef.player;

      // the no-skip rules only apply while the lesson is not finished yet
      const savedProgress = this.findLessonProgress();
      this.isLessonWatched = !!(savedProgress && savedProgress.status === 1);

      // Seed the ceiling from the stored position so a later save can never
      // drag the saved progress backwards, even if the resume seek is skipped.
      const storedSec = this.storedPositionSec();
      if (storedSec > 0) {
        this.maxWatched = storedSec;
      }

      // resume at the last watched position once duration is known
      player.on("loadedmetadata", () => {
        this.applyResume(player);
      });

      // Track real playback: grow the watched ceiling, persist the position,
      // and complete only once the video is actually watched through to the end.
      player.on("timeupdate", () => {
        if (this.syncSlide.length > 0) {
          this.syncSlideProcess(player.currentTime);
        }
        this.trackPlayback(player);
      });

      // A forward jump fires "timeupdate" with the new position *before*
      // "seeked", so flag the seek to stop it counting as watched time.
      player.on("seeking", () => {
        this.isSeeking = true;
      });

      player.on("seeked", () => {
        this.enforceSeekLock(player);
        this.isSeeking = false;
      });

      // block speeding up (>1x) to rush through the video
      player.on("ratechange", () => {
        this.enforceSpeedLimit(player);
      });

      player.on("play", () => {
        // the notice replaces this first play; playback restarts when it closes
        if (this.maybeShowVideoRuleNotice(player)) {
          return;
        }
        this.playTimeInterval = setInterval(() => {
          this.playTime++;
        }, 1);
      });

      player.on("pause", () => {
        clearInterval(this.playTimeInterval);
        this.savePosition(player);
      });

      // binding happens after several awaits, so "loadedmetadata" may already
      // have fired; try resuming immediately as well (applyResume is one-shot)
      this.applyResume(player);
    },
    // Spell out how a video lesson is graded the first time the user presses
    // play, and hold playback until they acknowledge it. Only while the lesson
    // is unfinished -- once it is done the seek lock is released and the green
    // eye is already on the row, so there is nothing left to warn about.
    // Returns true when playback was held back.
    maybeShowVideoRuleNotice(player) {
      if (
        this.videoRuleAcknowledged ||
        !this.hasVideoLesson ||
        !this.isLocked()
      ) {
        return false;
      }
      player.pause();
      this.$bvModal.show("video-rule-modal");
      return true;
    },
    closeVideoRuleModal() {
      this.$bvModal.hide("video-rule-modal");
    },
    onVideoRuleHidden() {
      // resume the play the notice interrupted; the flag keeps later plays
      // (after a pause, or a rewind) from showing it again
      this.videoRuleAcknowledged = true;
      const player = this.$refs.player && this.$refs.player.player;
      if (!player) {
        return;
      }
      const playing = player.play();
      if (playing && typeof playing.catch === "function") {
        playing.catch(() => {});
      }
    },
    findLessonProgress() {
      if (!Array.isArray(this.progressResponse) || !this.lesson) {
        return null;
      }
      return (
        this.progressResponse.find(
          (item) => item.lesson_id == this.lesson.id
        ) || null
      );
    },
    storedPositionSec() {
      const savedProgress = this.findLessonProgress();
      return Number(
        (savedProgress && savedProgress.lesson_time_sec) ||
          this.$route.query.sec ||
          0
      );
    },
    isLocked() {
      // no-skip / no-fast-forward applies only until the lesson is finished,
      // whether it was finished earlier or during this session
      return !this.isLessonWatched && !this.progressSaved;
    },
    trackPlayback(player) {
      const duration = player.duration;
      const currentTime = player.currentTime;
      if (!duration || isNaN(duration) || duration <= 0) {
        return;
      }

      // Only credit continuous playback: a big jump means the user seeked,
      // so it must not raise the ceiling that the seek lock relies on.
      const SEEK_EPS = 2;
      const delta = currentTime - this.maxWatched;
      if (!this.isSeeking && delta > 0 && delta <= SEEK_EPS) {
        this.maxWatched = currentTime;
      }

      if (!this.isLocked()) {
        return;
      }

      // persist the real position periodically so the lesson can resume later
      const now = Date.now();
      if (now - this.lastPositionSaveAt >= 10000) {
        this.lastPositionSaveAt = now;
        this.updateProgress(this.maxWatched, duration);
      }

      if (this.isWatchedEnough(currentTime, duration)) {
        this.saveProgressAndRefresh(currentTime, duration);
      }
    },
    isWatchedEnough(currentTime, duration) {
      // must be watched through to the end (small tolerance for rounding)
      return currentTime >= duration - 2;
    },
    applyResume(player) {
      if (this.resumeApplied) {
        return;
      }
      const duration = player.duration;
      if (!duration || isNaN(duration) || duration <= 0) {
        return;
      }
      const resumeSec = this.storedPositionSec();
      if (resumeSec > 0 && resumeSec < duration - 2) {
        this.maxWatched = Math.max(this.maxWatched, resumeSec);
        player.currentTime = resumeSec;
      }
      this.resumeApplied = true;
    },
    enforceSeekLock(player) {
      if (!this.isLocked()) {
        return;
      }
      // rewinding is allowed; jumping ahead of what was watched is not
      const SEEK_EPS = 2;
      if (player.currentTime > this.maxWatched + SEEK_EPS) {
        player.currentTime = this.maxWatched;
      }
    },
    enforceSpeedLimit(player) {
      if (!this.isLocked()) {
        return;
      }
      if (player.speed > 1) {
        player.speed = 1;
      }
    },
    savePosition(player) {
      // a finished lesson needs no position tracking, and writing a small
      // position would drag the stored lesson_time_sec backwards
      if (!this.isLocked()) {
        return;
      }
      const duration = player.duration;
      if (
        !duration ||
        isNaN(duration) ||
        duration <= 0 ||
        this.maxWatched <= 0
      ) {
        return;
      }
      // always report the furthest watched point so the value never regresses
      this.updateProgress(this.maxWatched, duration);
    },
    async saveProgressAndRefresh(currentTime, duration) {
      if (this.savingProgress) {
        return;
      }
      this.savingProgress = true;
      const ok = await this.updateProgress(currentTime, duration);
      if (ok) {
        this.progressSaved = true;
        // refresh the eye icon without reloading the whole page
        await this.getLessonProgress();
      }
      this.savingProgress = false;
    },
    async updateProgress(currentTime, duration) {
      const model = {
        user_id: this.userData.id,
        subject_id: this.lesson.subject_id,
        lesson_id: this.lesson.id,
        lesson_time_sec: currentTime,
        duration: duration,
        enroll_id: this.courseStatus.enroll_id,
        play_time: this.playTime,
      };
      try {
        await this.$store.dispatch("Lessons/saveLessonProgress", {
          model,
          accessToken: this.access_token,
        });
        return true;
      } catch (err) {
        if (err.response && err.response.status == 401) {
          this.$store.dispatch("Auth/logout").then(() => {
            this.$router.push("/login");
          });
        }
        return false;
      }
    },
    // Change Page when Video play to the page time
    async syncSlideProcess(currentTime) {
      this.syncSlide.forEach((model, index) => {
        if (index + 1 < this.syncSlide.length) {
          if (
            currentTime >= this.syncSlide[index].total_second &&
            currentTime <= this.syncSlide[index + 1].total_second
          ) {
            if (this.page != model.page) {
              this.page = model.page;
            }
            return;
          }
        } else {
          if (currentTime >= this.syncSlide[index].total_second) {
            if (this.page != model.page) {
              this.page = model.page;
            }
            return;
          }
        }
      });
    },

    // Prepare
    changeFormatSyncSlide() {
      if (this.lesson.sync_slide) {
        this.syncSlide = JSON.parse(this.lesson.sync_slide);
        this.syncSlide = this.syncSlide.map((x) => {
          let page = parseInt(x.page);
          let total_second = parseInt(x.total_second);
          return { page: page, total_second: total_second };
        });
        this.syncSlide.sort(function (a, b) {
          return a.total_second - b.total_second;
        });
      }
    },

    async teacherDetail(id) {
      let path = `/teacher-detail`;
      await this.$router.push({
        path: path,
        query: { id: id },
      });
    },
    async checkCourseStatus() {
      const model = {
        user_id: this.userData.id,
        subject_id: this.course.id,
      };

      let courseResponse;
      try {
        courseResponse = await this.$store.dispatch(
          "Courses/checkCourseStatus",
          {
            model,
            accessToken: this.access_token,
          }
        );

        this.courseStatus = courseResponse;
        if (this.courseStatus) {
          if (this.courseStatus.isBan) {
            let path = `/courses`;
            await this.$router.push({
              path: path,
              query: { id: this.$route.query.courseId },
            });
          }
        }
      } catch (err) {
        this.isLoading = false;
        this.courseStatus = null;
      }

      let answerResponse;
      try {
        answerResponse = await this.$store.dispatch("Courses/getCourseAnswer", {
          id: this.course.id,
          accessToken: this.access_token,
          enrollId: this.courseStatus.enroll_id,
        });

        this.answerCourse = answerResponse;
      } catch (err) {
        this.isLoading = false;
        this.answerCourse = false;
      }

      await this.getLessonProgress();
    },
    downloadFile(link) {
      window.open(link, "_blank");
    },
    async getContent() {
      const course = this.$route.query.courseId;
      const lesson = this.$route.query.lessonId;
      if (course || lesson) {
        await this.$store.dispatch("Courses/getCourse", {
          id: course,
          user_id: this.userData.id,
        });
        await this.$store.dispatch("Lessons/getLessons", lesson);

        this.$forceUpdate();
        this.isGetContent = true;
      } else {
        this.$router.push("/");
      }
    },
    async getLessonProgress() {
      let progressResponse;
      try {
        progressResponse = await this.$store.dispatch(
          "Courses/onGetLessonProgess",
          {
            subjectId: this.course.id,
            enrollId: this.courseStatus.enroll_id,
            accessToken: this.access_token,
          }
        );

        this.progressResponse = progressResponse;
      } catch (error) {
        this.progressResponse = false;
      }
    },
    checkEnroll(enrolls) {
      let rs = false;

      if (!Array.isArray(enrolls) || (enrolls && enrolls.length === 0)) {
        this.noEnroll = true;
        rs = false;
      } else {
        const enrollsActive = enrolls.filter((enroll) => enroll.status);
        if (enrollsActive && enrollsActive.length <= 0) {
          rs = false;
        } else {
          const now = moment();
          // enrollsActive.forEach((enroll) => {
          // A course can have several enrollment rounds and the API order is not
          // meaningful, so evaluate the round this user is actually registered
          // in; fall back to the first one for the "not registered yet" path.
          const registered = enrolls.find(
            (e) => e.user_enroll && e.user_enroll.length > 0
          );
          const enroll = registered ?? enrolls[0];
          const start_at = moment(enroll.register_start);
          const end_at = moment(enroll.register_end);

          const course_start_at = moment(enroll.course_start);
          const course_end_at = moment(enroll.course_end);

          if (
            now.isBetween(start_at, end_at) &&
            now.isBetween(course_start_at, course_end_at)
          ) {
            // if( (start_at && end_at) && (course_start_at && course_end_at) ){
            if (
              this.course.access_rights === "public" ||
              (this.course.access_rights === "private" &&
                this.course.approve_right !== null)
            ) {
              if (
                enroll.user_enroll &&
                enroll.user_enroll.length > 0 &&
                course_end_at.isAfter(now)
              ) {
                rs = true;
              } else if (
                enroll.user_enroll &&
                enroll.user_enroll.length == 0 &&
                end_at.isAfter(now)
              ) {
                rs = false;
              }
            }
          }
          // });
        }
      }
      return rs;
    },
    async videoEnd() {
      // Guarantee the lesson is marked watched when the video finishes,
      // then refresh the eye icon in place instead of reloading the page
      // (a reload can abort the in-flight save request and lose progress).
      if (!this.progressSaved) {
        const playerRef = this.$refs.player;
        const player = playerRef && playerRef.player;
        let duration = player ? player.duration : null;
        if (!duration || isNaN(duration) || duration <= 0) {
          duration = this.lesson.media ? this.lesson.media.duration : null;
        }
        if (duration && !isNaN(duration) && duration > 0) {
          await this.saveProgressAndRefresh(duration, duration);
        }
      } else {
        await this.getLessonProgress();
      }
    },
  },
};
</script>

<style>
.absolute-img {
  position: absolute;
  z-index: 500;
  width: 120px;
  top: 4%;
  right: 4%;
}
</style>
